export default __webpack_public_path__ + "static/media/faq-arrow.1b57139f.svg";